import { sha256 } from 'js-sha256';

export const create256Hash = (content: string) => sha256.update(content).hex();

export const createHMACSHA256Hash = (key: string, content: string): string =>
  sha256.hmac.create(key).update(content).hex();

export const urlSafeBase64Encode = (plain: string): string => {
  try {
    // Encode the input string to Base64
    let base64 = btoa(plain);
    // Replace Base64 characters to make it URL-safe
    base64 = base64.replace(/\+/g, '-').replace(/\//g, '_');
    // Remove any trailing '=' characters
    return base64.replace(/=+$/, '');
  } catch (error) {
    // Catch and handle the error
    console.error('Encoding error:', error);
    return undefined;
  }
};

export const urlSafeBase64Decode = (encoded: string): string => {
  try {
    // Replace URL-safe characters
    let base64 = encoded.replace(/-/g, '+').replace(/_/g, '/');
    // Add padding if necessary
    const padding = base64.length % 4;
    if (padding) {
      base64 += '='.repeat(4 - padding);
    }
    // Decode the Base64 string
    return atob(base64);
  } catch (error) {
    // Catch and handle the error
    console.error('Decoding error:', error);
    return undefined;
  }
};
